const ICONS = {
  LOGO: "logo",
  RIGHT_ARROW: "right_arrow",
  SECOND_RIGHT_ARROW: "second_right_arrow",
  APP_STORE: "app_store",
  GOOGLE_PLAY: "google_play",
  LINKEDIN: "linkedin",
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  PHONE: "phone",
  EMAIL: "email",
  ALERT_ERROR: "alert_error",
  ALERT_SUCCESS: "alert_success",
  BUILDING: "building",
  HELMET: "helmet",
  MEET: "meet",
  TEACH: "teach",
  DOCUMENT: "document",
  CHECK: "check",
  SECOND_CHECK: "second_check",
  SAFE_CASE: "safe_case",
  LOST_CONNECTION: "lost_connection",
  MONEY: "money",
  EXCLAMATION_MARK: "exclamation_mark",
  LINK: "link",
  ARROW_DOWN: "arrow_down",
  LINKEDIN_FULL: "linkedin_full",
  CLOSE: "close",
  SETTING: "settings",
  LEFT: "left",
  RIGHT: "right",
  CLASS: "class",
  LIGHT_BUBLE: "light_buble",
  BRIEFCASE: "briefcase",
  TARGET: "target",
  FILTER_CHECK: "filter_check",
  GEAR: "gear",
  TIME: "time",
  GLOBE: "globe",
  BOOK: "book",
  MEDAL: "medal",
  RESUME: "resume",
  SHIELD: "shield",
  FOLDER: "folder",
  ANALYTICS: "analytics",
  USERS: "users",
  USER_VERIFIED: "user_verified",
  NEWS: "news",
  ZOOM: "zoom",
  CHART: "chart",
  GANTT_CHART: "gantt_chart",
  HAND_SHAKE: "hand_shake",
  WARNING: "warning",
  QUOTE_MARKS: "quote_marks",
  LOCATION: "location",
  CONTRACTORS_AND_OPERATORS: "contractors_and_operators",
  EQUIPMENT_MANUFACTURES: "equipment_manufacturers",
};

export default ICONS;
